<template>
  <section class="max-w-[1440px] mx-auto px-12 py-12 space-y-12">

    <!-- HEADER -->
    <header>
      <h2 class="text-4xl font-black tracking-tight">
        Compare Influencers
      </h2>
      <p class="text-slate-400 mt-2 max-w-2xl">
        Side-by-side evaluation using verified, aggregated audience data.
      </p>
    </header>

    <!-- COMPARE GRID -->
    <section class="grid grid-cols-1 lg:grid-cols-3 gap-8">

      <div
        v-for="i in influencers"
        :key="i.id"
        class="bg-white p-8 rounded-[2.5rem] premium-shadow border border-slate-50
               flex flex-col"
      >
        <!-- HEADER -->
        <div class="flex items-center gap-4 mb-6">
          <div
            class="size-14 rounded-full bg-slate-900 text-white
                   flex items-center justify-center text-xl font-black"
          >
            {{ i.name.charAt(0) }}
          </div>

          <div>
            <h3 class="font-bold text-lg">
              {{ i.name }}
            </h3>
            <p class="text-xs text-slate-400">
              {{ i.platform }} · {{ i.category }}
            </p>
          </div>
        </div>

        <!-- KPIs -->
        <div class="space-y-4 text-sm">
          <div class="flex justify-between">
            <span class="text-slate-400">Verified Fans</span>
            <strong>{{ i.fans }}</strong>
          </div>

          <div class="flex justify-between">
            <span class="text-slate-400">Monthly Growth</span>
            <strong>{{ i.growth }}%</strong>
          </div>

          <div class="flex justify-between">
            <span class="text-slate-400">Engagement Health</span>
            <strong>{{ i.engagement }}%</strong>
          </div>

          <div class="flex justify-between">
            <span class="text-slate-400">Audience Quality</span>
            <strong>{{ i.quality }}/10</strong>
          </div>
        </div>

        <!-- INTERESTS -->
        <div class="mt-6">
          <h4 class="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">
            Top Interests
          </h4>

          <ul class="space-y-2 text-sm">
            <li
              v-for="interest in i.interests"
              :key="interest"
              class="flex items-center gap-2"
            >
              <span class="size-2 rounded-full bg-slate-900"></span>
              {{ interest }}
            </li>
          </ul>
        </div>

        <!-- ACTION -->
        <div class="mt-auto pt-8 space-y-3">
          <button
            class="bg-primary text-white w-full py-3 rounded-xl
                   font-bold text-xs uppercase tracking-wider
                   hover:opacity-90 transition"
          >
            View Profile
          </button>

          <button
            class="w-full py-3 rounded-xl border border-slate-200
                   text-xs font-bold uppercase tracking-wider
                   hover:bg-slate-50 transition"
          >
            Select for Campaign
          </button>
        </div>
      </div>

    </section>

    <!-- DISCLAIMER -->
    <section
      class="bg-slate-50 p-8 rounded-[2rem]
             text-center text-xs text-slate-400"
    >
      Comparison is based on anonymized, aggregated audience intelligence.
      Individual fan data is never shared.
    </section>

  </section>
</template>

<script>
export default {
  name: "AgencyInfluencerCompare",

  data() {
    return {
      influencers: [
        {
          id: 1,
          name: "Rahul Mehta",
          platform: "Instagram",
          category: "Technology",
          fans: "120K",
          growth: 9.4,
          engagement: 92,
          quality: 8.7,
          interests: ["AI", "Startups", "Tech News"]
        },
        {
          id: 2,
          name: "Neha Sharma",
          platform: "YouTube",
          category: "Education",
          fans: "340K",
          growth: 6.2,
          engagement: 88,
          quality: 8.1,
          interests: ["Career", "Learning", "Productivity"]
        },
        {
          id: 3,
          name: "Aman Verma",
          platform: "LinkedIn",
          category: "Finance",
          fans: "95K",
          growth: 7.8,
          engagement: 90,
          quality: 8.4,
          interests: ["Investing", "Markets", "Economy"]
        }
      ]
    };
  }
};
</script>
